import React from 'react';

export default {
  requestProcessStatement: 'Erstellt aus den ausgewählten Ergebnis eine Stellungnahme-Anfrage'
}
